__turbopack_context__.v({
  "inverted": "TeasersItem-module-scss-module__EFnD0q__inverted",
  "teaser": "TeasersItem-module-scss-module__EFnD0q__teaser",
  "teaserdisclaimer": "TeasersItem-module-scss-module__EFnD0q__teaserdisclaimer",
  "teaserimage": "TeasersItem-module-scss-module__EFnD0q__teaserimage",
  "teaserlinks": "TeasersItem-module-scss-module__EFnD0q__teaserlinks",
  "teaserparagraph": "TeasersItem-module-scss-module__EFnD0q__teaserparagraph",
  "teasertext": "TeasersItem-module-scss-module__EFnD0q__teasertext",
});
